// import React from "react";
// import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
// import { useSelector } from "react-redux";
// import ComingBack from "./pages/ComingBack";
// import "./App.css";
// import Login from "./pages/Login/Login";
// import Registration from "./pages/Registration";
// import AuthRoute from "./components/AuthRoute";
// import { FETCHED_USER, selectUser } from "./store/reducers/auth.reducers";
// import BinaryDetails from "./pages/Team/Tree";
// import Dashboard from "./pages/Dashboard";
// import { useState } from "react";
// import { useEffect } from "react";
// import { useDispatch } from "react-redux";

// function App() {
//   const [isLoading, setIsLoading] = useState(true);

//   const user = useSelector((state) => selectUser(state));
//   const dispatch = useDispatch();

//   // useEffect(() => {
//   //   localStorage.removeItem("freecoinToken");
//   //   dispatch(REMOVED_USER());
//   //   setIsLoading(false);
//   // }, []);

//   useEffect(() => {
//     if (localStorage.getItem("freecoinToken")) {
//       const fetchUser = () => {
//         const data = localStorage.getItem("freecoinToken");
//         console.log(JSON.parse(data));
//         dispatch(FETCHED_USER(JSON.parse(data)));
//       };
//       fetchUser();
//     }
//     setIsLoading(false);
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, []);

//   if (isLoading) return <p>Loading...</p>;

//   return (
//     <Router>
//       <Switch>
//         <Route
//           path="/referral-link/:parentRefId/:type"
//           component={Registration}
//           exact
//         />
//         <Route path="/register-user" component={Registration} exact />
//         <AuthRoute
//           path="/tree-chart"
//           Component={BinaryDetails}
//           condition={!user}
//           redirectTo="/login"
//         />
//         <AuthRoute
//           path="/login"
//           Component={Login}
//           condition={user}
//           redirectTo="/"
//         />
//         <AuthRoute
//           path="/"
//           Component={Dashboard}
//           condition={!user}
//           redirectTo="/login"
//         />
//         {/*
//         //under construction
//         <AuthRoute
//           path="/"
//           Component={ComingBack}
        
//         /> */}
//       </Switch>
//     </Router>
//   );
// }



// export default App;

import React from "react";
import "./App.css";

function App() {
  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#0056d6",
        color: "#ffffff",
        padding: "24px",
        textAlign: "center",
      }}
    >
      <div
        style={{
          maxWidth: "700px",
          width: "100%",
          backgroundColor: "#ffffff",
          color: "#0c1420",
          borderRadius: "12px",
          padding: "40px 32px",
          boxShadow: "0 10px 40px rgba(0, 0, 0, 0.3)",
        }}
      >
        <h1 style={{ marginBottom: "20px" }}>Dear Freeminers Family,</h1>
        <p style={{ fontSize: "18px", lineHeight: "1.7", marginBottom: "16px" }}>
          We&rsquo;re currently working on an exciting{" "}
          <em>product update and system enhancement</em> to provide you with a
          better experience.
        </p>
        <p style={{ fontSize: "18px", lineHeight: "1.7", marginBottom: "16px" }}>
          As part of this update, the{" "}
          <em>
            Freeminers website will be temporarily unavailable for maintenance
            for approximately 15 days
          </em>
          .
        </p>
        <p style={{ fontSize: "18px", lineHeight: "1.7", marginBottom: "16px" }}>
          We sincerely apologize for any inconvenience this may cause and truly
          appreciate your{" "}
          <em>patience, understanding, and continued support</em>.
        </p>
        <p style={{ fontSize: "18px", lineHeight: "1.7", marginBottom: "16px" }}>
          We look forward to welcoming you back with an improved experience
          soon. ❤️
        </p>
        <p
          style={{
            fontSize: "18px",
            lineHeight: "1.7",
            marginBottom: "24px",
          }}
        >
          <em>Thank you for being a part of the Freeminers Family!</em>
        </p>
        <p style={{ fontSize: "18px", fontWeight: "bold" }}>
          &mdash; <em>Team Freeminers</em>
        </p>
      </div>
    </div>
  );
}

export default App;
